import React from 'react';
import { Mail } from 'lucide-react';
import { coach } from '../config/coach';

const Footer = () => {
  const year = new Date().getFullYear();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="relative bg-black border-t border-white/10 pt-16 pb-10" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        {/* Massive wordmark */}
        <div className="border-b border-white/10 pb-10">
          <h2 className="font-display font-bold uppercase text-white/90 leading-[0.82] tracking-tight text-[14vw] sm:text-[10vw] lg:text-[9rem]">
            SOPHIE HERRIOT
          </h2>
        </div>

        <div className="pt-10 grid gap-10 sm:grid-cols-3">
          <div>
            <p className="font-display uppercase tracking-[0.3em] text-white/40 text-xs mb-3">Coaching</p>
            <p className="text-white/60 text-sm max-w-xs leading-relaxed">
              1-on-1 online fitness coaching. Personalized training, realistic nutrition and consistent accountability.
            </p>
          </div>

          <div>
            <p className="font-display uppercase tracking-[0.3em] text-white/40 text-xs mb-3">Explore</p>
            <ul className="space-y-2">
              {[
                { label: 'Approach', id: 'results' },
                { label: 'Story', id: 'about' },
                { label: 'What You Get', id: 'what-you-get' },
                { label: 'Apply', id: 'apply' },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollTo(l.id)}
                    data-testid={`footer-link-${l.id}`}
                    className="text-white/60 hover:text-white text-sm transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-display uppercase tracking-[0.3em] text-white/40 text-xs mb-3">Contact</p>
            <a
              href={`mailto:${coach.email}`}
              data-testid="footer-email-link"
              className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors"
            >
              <Mail className="w-4 h-4" />
              {coach.email}
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/35 text-xs tracking-wide">© {year} Sophie Herriot Coaching. All rights reserved.</p>
          <p className="text-white/25 text-xs tracking-wide">Strength • Confidence • Performance</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
